import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {NextUIProvider} from "@nextui-org/react";
import Navigation from "./routes/routes";
import {BrowserRouter} from "react-router-dom";
import { PrimeReactProvider } from 'primereact/api';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import {RecoilRoot} from "recoil";
import {ChakraProvider} from "@chakra-ui/react";



const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <BrowserRouter>
      <RecoilRoot>
          <ChakraProvider>
          <NextUIProvider>
              <PrimeReactProvider>
                  <Navigation />
              </PrimeReactProvider>
          </NextUIProvider>
          </ChakraProvider>
      </RecoilRoot>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
